import {AlbumSummary} from './AlbumSummary';

export class AlbumSummaryCollection {
  albumSummaries: AlbumSummary[];

  constructor() {
    this.albumSummaries = new Array<AlbumSummary>();
  }

  deserializeAlbums(albumsJson: AlbumSummary[]): void {
    for (const albumJson of albumsJson) {
      const albumSummary = new AlbumSummary();
      albumSummary.deserialize(albumJson);
      this.albumSummaries.push(albumSummary);
    }
  }
}
